/**
 *
 * Asynchronously loads the component for ConfigurationManager
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
